import _ from "lodash";
import USER_DETAILS from "../graphql/user/UserDetails.gql";
import COMPANY_USER from "../graphql/user/CompanyUser.gql";
import COMPANY_ACCOUNTABLE_ACCOUNT_TABLE from "../graphql/accountableAccount/companyAccountableAccountTable.gql";
import { RootState, User } from "@/store/store";
import { AuthServices } from "./auth.services";
import { Store } from "vuex";
import { Company } from "../../../types/types/indexTypes";
import { Router } from "vue-router";
import { ApolloClient, NormalizedCacheObject } from "@apollo/client/core";
import { getAccountingFirmFromUser, getAccountingFirmClient } from "./companyServices";
import { DollarApollo } from "@vue/apollo-option/types/vue-apollo";
import { ComponentPublicInstance } from "vue";

let firstCall = true;
type DisplayNameUser = Partial<User> & { marriedName?: string };

export function getUserBigram(user: DisplayNameUser): string {
    if (!user) {
        return "";
    }
    if (user.firstname) {
        if (user.marriedName) {
            return user.firstname.charAt(0) + user.marriedName.charAt(0);
        }
        if (user.lastname) {
            return user.firstname.charAt(0) + user.lastname.charAt(0);
        }
        return user.firstname.length >= 2
            ? user.firstname.substring(0, 2)
            : user.firstname.charAt(0);
    }
    if (user.marriedName) {
        return user.marriedName.length >= 2
            ? user.marriedName.substring(0, 2)
            : user.marriedName.charAt(0);
    }
    if (user.lastname) {
        return user.lastname.length >= 2 ? user.lastname.substring(0, 2) : user.lastname.charAt(0);
    }
    return "";
}

export function getUserDisplayName(user: DisplayNameUser) {
    // console.log("AccountbaleAccountUser", user)
    if (user) {
        let name = user.firstname || "";
        if (user.marriedName) {
            name += name ? " " : "";
            name += user.marriedName;
        } else if (user.lastname) {
            name += name ? " " : "";
            name += user.lastname;
        }
        return name;
    }
    return "Xxx Xxxx";
}

/**
 * Updates the user object and it's subUser in the VueX Store
 * @param apollo the ApolloClient or this.$apollo
 * @param store the Store (from store.ts)
 * @param user You don't need the whole object, only the userId m isSubUserOf and the subusers with their Ids
 * @returns the updated user
 */
export async function updateStoreUserAndSubUser(
    apollo: ApolloClient<NormalizedCacheObject> | DollarApollo<ComponentPublicInstance>,
    store: Store<RootState>,
    user: Pick<User, "id" | "subUsers" | "isSubUserOf">,
): Promise<User> {
    if ("provider" in apollo) {
        apollo = apollo.provider.defaultClient;
    }
    if (store.state.subUserId) {
        let found: boolean;
        if (user?.id === store.state.subUserId) {
            found = true;
            // store.commit("updateAccountingFirmId", loggedUser.company.id)
        }
        if (!user.subUsers) {
            //debugger;
            // ADD subUsers on user query
        }
        if (user.subUsers?.length) {
            const subUser = user.subUsers.find((su) => su.id === store.state.subUserId);
            if (subUser) {
                found = true;
                // store.commit("updateAccountingFirmId", subUser.company.id)
            }
        }
        if (!found) {
            store.commit("updateSubUserId", null);
            // store.commit("updateAccountingFirmId", null)
        }
    } else if (user.isSubUserOf) {
        // should never happen
        store.commit("updateSubUserId", user.id);
    }
    return await updateStoreUser(apollo, store, user.id);
}

/**
 *  Updates the store User
 * @param apollo either the apollo client or this.$apollo
 * @param store the Store (from store.ts)
 * @param userId  a string containing the user ID
 * @returns the store's user
 */
export async function updateStoreUser(
    apollo: ApolloClient<NormalizedCacheObject> | DollarApollo<ComponentPublicInstance>,
    store: Store<RootState>,
    userId: string,
): Promise<User> {
    if ("provider" in apollo) {
        apollo = apollo.provider.defaultClient;
    }
    if (!userId) {
        store.commit("setUser", null);
        finisUpdate(apollo, store, null);
        return;
    }
    const userDetails = await apollo.query({
        query: USER_DETAILS,
        fetchPolicy: "network-only",
        variables: {
            id: userId,
        },
    });
    const user = _.cloneDeep(userDetails.data.user);
    const userHasChanged = user?.id !== store.state.user?.id;

    if (user?.profile?.id && user?.switchProfile?.id && user.profile.id !== user.switchProfile.id) {
        if (!user.switchOriginalProfile) {
            user.switchOriginalProfile = user.profile;
        }
        user.profile = user.switchProfile;
    }
    const selectedCompany = await checkSelectedCompany(apollo, store, user);
    store.commit("setUser", user);
    if (firstCall || userHasChanged) {
        finisUpdate(apollo, store, selectedCompany);
    }
    firstCall = false;
    return store.state.user;
}
/**
 * This function calls getAccountableAccountTable.
 * @param apollo either the apollo client or this.$apollo
 * @param store the Store (from store.ts)
 * @param selectedCompany
 */
async function finisUpdate(
    apollo: ApolloClient<NormalizedCacheObject> | DollarApollo<ComponentPublicInstance>,
    store: Store<RootState>,
    selectedCompany: Pick<Company, "id">,
) {
    if ("provider" in apollo) {
        apollo = apollo.provider.defaultClient;
    }
    getAccountableAccountTable(apollo, store, selectedCompany);
}
async function checkSelectedCompany(apollo, store, user) {
    // debugger;
    let selectedCompany = store.state.selected_company;
    // if (!store.state.inAdmin) {
    if (selectedCompany || !store.state.inAdmin) {
        if (user.allAvailableCompanies?.length) {
            if (selectedCompany) {
                selectedCompany =
                    user.allAvailableCompanies.find(
                        (company) => company.id === selectedCompany.id,
                    ) || null;
                if (!selectedCompany) {
                    selectedCompany = user.allAvailableCompanies[0];
                }
            } else {
                selectedCompany = user.allAvailableCompanies[0];
            }
        } else {
            selectedCompany = null;
        }
    }
    await setCurrentCompany(apollo, store, selectedCompany, user);
    return selectedCompany;
}

export async function setCurrentCompany(
    apollo: ApolloClient<NormalizedCacheObject> | DollarApollo<ComponentPublicInstance>,
    store: Store<RootState>,
    company: Pick<Company, "id">,
    inUser = null,
    onlyIfDifferent: boolean = false,
) {
    if ("provider" in apollo) {
        apollo = apollo.provider.defaultClient;
    }
    const user = inUser || store.state.user;
    if (!user) {
        console.error("No user in setCurrentCompany");
        return;
    }
    const companyChanged =
        !company || !store.state.selected_company || company.id !== store.state.selected_company.id;
    if (onlyIfDifferent && !firstCall) {
        if (!companyChanged) {
            return;
        }
    }
    let companyAccountingFirm = null;
    let accountingFirmClient = null;
    if (company) {
        const queryResult = await apollo.query({
            query: COMPANY_USER,
            fetchPolicy: "network-only",
            variables: {
                companyId: company.id,
                userId: user.id,
            },
        });
        if (queryResult?.data?.companyUserFirst) {
            const companyUser = _.cloneDeep(queryResult.data.companyUserFirst);
            if (companyUser.profile) {
                if (!user.companyUserOriginalProfile) {
                    user.companyUserOriginalProfile = user.profile;
                }
                user.profile = companyUser.profile;
            }
            user.companyUser = companyUser;
        } else {
            user.companyUser = null;
            if (user.companyUserOriginalProfile) {
                user.profile = user.companyUserOriginalProfile;
                user.companyUserOriginalProfile = null;
            }
        }

        if (
            user?.profile?.id &&
            user?.switchProfile?.id &&
            user.profile.id !== user.switchProfile.id
        ) {
            if (!user.switchOriginalProfile) {
                user.switchOriginalProfile = user.profile;
            }
            user.profile = user.switchProfile;
        }
    } else {
        // Vérifier avec Eric
        if (user?.switchOriginalProfile?.id) {
            user.profile = user.switchOriginalProfile;
            user.switchOriginalProfile = null;
        }

        if (user.companyUserOriginalProfile) {
            user.profile = user.companyUserOriginalProfile;
            user.companyUserOriginalProfile = null;
        }
    }

    const accountingFirm = await getAccountingFirmFromUser(apollo, user);
    // const companyToUse = store.state.inAdmin ? accountingFirm : company
    // debugger
    if (company) {
        accountingFirmClient = await getAccountingFirmClient(
            apollo,
            accountingFirm || company,
            company,
        );
    }
    if (accountingFirm) {
        companyAccountingFirm = accountingFirm;
    }

    user.selectedCompany = company;

    store.commit("setCurrentCompany", company);
    store.commit("setCompanyAccountingFirm", companyAccountingFirm);
    store.commit("setAccountingFirmClient", accountingFirmClient);

    if (!inUser) {
        finisUpdate(apollo, store, company);
    }
}
/**
 * Queries the apollo server to get the accountable account tables, and then commits them in the store.
 * @param apollo either the apollo client or this.$apollo
 * @param store the Store (from store.ts)
 * @param company an object containing only the id of the company
 */
export async function getAccountableAccountTable(
    apollo: ApolloClient<NormalizedCacheObject> | DollarApollo<ComponentPublicInstance>,
    store: Store<RootState>,
    company: Pick<Company, "id">,
): Promise<void> {
    if ("provider" in apollo) {
        apollo = apollo.provider.defaultClient;
    }
    if (company) {
        const result = await apollo.query({
            query: COMPANY_ACCOUNTABLE_ACCOUNT_TABLE,
            fetchPolicy: "network-only",
            variables: {
                companyId: company.id,
            },
        });
        if (result?.data?.companyAccountableAccountTable) {
            store.commit(
                "updateAccountableAccountTable",
                result.data.companyAccountableAccountTable,
            );
        } else {
            store.commit("updateAccountableAccountTable", null);
        }
    } else {
        store.commit("updateAccountableAccountTable", null);
    }
}

export async function logOutUser(store: Store<RootState>, router: Router) {
    store.commit("beforeLogoutUser");
    router.push({ name: "login" });
    await AuthServices.logout();
    sessionStorage.clear();
    // do no remove => force reset store for cognito (bypass)
    window.location.reload();
}
